(function(){
    angular
        .module('appback')
        .directive('ngAccionespedido', accionesPedido);

        accionesPedido.$inject = ['PedidosService','GenerallabService','$timeout', 'Upload'];
        function accionesPedido(PedidosService,GenerallabService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=accionescontenido.twig',
		          scope: {
                  acciones:'=',
                  pedidoactivo:'=',
                  pedidoid: '=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
						console.log("ngAccionesPedido",scope);
		            	console.log("fabricacionid",scope.pedidoid);
                        scope.generalLab = GenerallabService;
						scope.nodeaccion = {};
						scope.resetInf = function(){
							scope.nodeaccion = {
								pedido_id: scope.pedidoid,
								accion:"",
								notificar_urano:0,
								notificar_clinica:0,		
							};
						}
						scope.evento = function(event){
							scope.eventoVar = event;
						}
						scope.resetInf();

						scope.uploadFiles = function(files){
							if(files && files.length){
								for(var i = 0;i<files.length; i++){
									console.log("Fichero a subir", files[i]);
									Upload.upload({
										url: '/backend/hojafabricacion/subirficheroaccion',
										data: { file: files[i] }
									}).then(function(resp){
										console.log("response upload fichero", resp);
										if(resp.data.code > 0){
											if(angular.isUndefined(scope.nodeaccion.ficheros)){
												scope.nodeaccion.ficheros = [];
											}
											scope.nodeaccion.ficheros.push(resp.data);
										}else{
											console.log("Error al subir fichero", resp);
										}
									});
								}
							}else{
								console.log("No hay archivos para subir");
							}
						}

						scope.loading = false;
						scope.guardarAccion = function(){
							scope.loading = true;
							scope.code = 0;
                            scope.nodeaccion.pedido_id = scope.pedidoid;
							console.log('agregar accion',scope.nodeaccion );
							PedidosService.setPedidoAccion(scope.nodeaccion,function(data){
								$timeout(function(){
                                    scope.pedidoactivo = data.pedido;
                                    scope.acciones = data.pedido.acciones;
                                    scope.resetInf();
								})
								scope.loading = false;
								scope.code = data.code;
							})
						}
			        });
		        }
          }
      }
})();